import script from "./CommentSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentSection.vue?vue&type=script&setup=true&lang=js"

import "./CommentSection.vue?vue&type=style&index=0&id=29f4d50a&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f4d50a"]])

export default __exports__